import {
  AaaGameConceptDataSet,
  GameConceptsQuery,
  IdXboxGameConceptDataSet,
} from "../../server/crm/api/models/forms";
import { PaginatedConceptData } from "../../server/crm/api/responses/getFullPaginatedConceptsResponse";
import { GameConceptsScope } from "../scopes";
import { createOnboardingAction, createOnboardingAsyncAction } from "./helpers/actionCreators";

export enum GameConceptsListActions {
  FETCH_START = "@gameConceptsList/FETCH_START",
  FETCH_COMPLETED = "@gameConceptsList/FETCH_COMPLETED",
  FETCH_ERROR = "@gameConceptsList/FETCH_ERROR",
  UPDATE_LIST = "@gameConceptsList/UPDATE_LIST",
  CLEAR_QUERY = "@gameConceptsList/CLEAR_QUERY",
}

export const gameConceptsListActions = {
  fetchGameConcepts: createOnboardingAsyncAction(
    GameConceptsScope,
    GameConceptsListActions.FETCH_START,
    (query: PaginatedConceptData) => ({ query }),
    GameConceptsListActions.FETCH_COMPLETED,
    (
      gameConceptsList: AaaGameConceptDataSet | IdXboxGameConceptDataSet,
      gameConceptsListQuery: GameConceptsQuery
    ) => ({ gameConceptsList, gameConceptsListQuery }),
    GameConceptsListActions.FETCH_ERROR,
    (error: Error) => ({ error })
  ),
  updateList: createOnboardingAction(
    GameConceptsListActions.UPDATE_LIST,
    GameConceptsScope,
    (
      gameConceptsList: AaaGameConceptDataSet | IdXboxGameConceptDataSet,
      gameConceptsListQuery: GameConceptsQuery,
      totalCount?: number
    ) => ({ gameConceptsList, gameConceptsListQuery, totalCount })
  ),
  clearQuery: createOnboardingAction(
    GameConceptsListActions.CLEAR_QUERY,
    GameConceptsScope,
    () => ({})
  ),
};
